/* eslint-disable react/require-default-props */
import * as React from "react";
import Collapsible from "react-collapsible";
import classNames from "classnames";

// Components
import MoreInfoTrigger from "../MoreInfoTrigger/MoreInfoTrigger";
import MoreInfoContent from "../MoreInfoContent/MoreInfoContent";
import InputTextField from "../InputTextField/InputTextField";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import InputRadio from "../InputRadio/InputRadio";
import InputNumberField from "../InputNumberField/InputNumberField";

// Misc
import useCondition from "../../lib/useCondition.lib";
import { useConditionDispatch } from "../../context/Condition.context";

// Types
import Statement from "../../types/Statement.interface";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

interface StatementWrapper {
  statement: Statement;
}

const StatementWrapper: React.FC<StatementWrapper> = (
  props: StatementWrapper
) => {
  const { statement } = props;
  const [showStatement] = useCondition(statement);
  const [isToggleOpen, setIsToggleOpen] = React.useState(false);
  const conditionDispatch = useConditionDispatch();

  const renderInputField = () => {
    const fieldMap = {
      text: InputTextField,
      checkbox: InputCheckbox,
      radio: InputRadio,
      number: InputNumberField,
    };

    const InputField = fieldMap[statement.type];

    if (statement.answers.length > 0) {
      return (
        <ErrorBoundary>
          <InputField
            id={statement._id}
            label={statement.statement}
            answers={statement.answers}
            feedback={statement.feedback}
          />
        </ErrorBoundary>
      );
    }
  };

  React.useEffect(() => {
    if (showStatement === false) {
      // conditionDispatch({
      //   type: "remove",
      //   payload: {
      //     id: statement._id,
      //   },
      // });
    }
  }, [showStatement]);

  const elementClasses = classNames({
    hidden: !showStatement,
  });

  return (
    <div className={elementClasses}>
      <div>{renderInputField()}</div>
      {statement.description && (
        <div className="mt-3 fix-top-margin">
          <Collapsible
            trigger={<MoreInfoTrigger />}
            easing="cubic-bezier(0.5, 1, 0.89, 1)"
            overflowWhenOpen="visible"
            open={isToggleOpen}
            handleTriggerClick={() => setIsToggleOpen(!isToggleOpen)}
          >
            <MoreInfoContent
              text={statement.description}
              closeFunc={() => setIsToggleOpen(false)}
            />
          </Collapsible>
        </div>
      )}
    </div>
  );
};

export default StatementWrapper;
